// getComponent is a function that returns a promise for a component
// It will not be called until the first mount
// useage: const Foo = asyncComponent(() => import('./Foo'))
import React from 'react'

export default function asyncComponent(getComponent) {
  return class AsyncComponent extends React.Component {
    static Component = null;
    state = { Component: AsyncComponent.Component };

    componentWillMount() {
      if (!this.state.Component) {
        getComponent().then(Component => {
          AsyncComponent.Component = Component
          this.setState({ Component })
        })
      }
    }
    render() {
      const { Component } = this.state
      if (Component) {
        return <Component {...this.props} />
      }
      return null
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/lib/react/async_component.js